import Nav from "@/components/cobain/Nav";
import GetFeatured from "@/components/cobain/GetFeatured";
import Footer from "@/components/cobain/Footer";

export default function GetFeaturedPage() {
  return (
    <main data-testid="get-featured-page">
      <Nav />
      <div className="pt-[72px]">
        <GetFeatured />
      </div>
      <Footer />
    </main>
  );
}
